import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, AlertController, ToastController, ActionSheetController, Events, ModalController, Config } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { TranslateService } from '@ngx-translate/core';
import { HomePage } from '../pages/home/home';
import { AppSettings } from '../services/app-settings';
import { AppVersion } from '@ionic-native/app-version';
import { Network } from '@ionic-native/network';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { TabsPage } from '../pages/tabs/tabs';
import { LoginPage } from '../pages/login/login';
import { WebPushService } from '../services/web-push.service';

import { LocalNotifications } from '@ionic-native/local-notifications';



@Component({
  templateUrl: 'app.html'
})



export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any;
  pages: Array<{
    title: string;
    component: any;
    icon: string;
    hideMenu: boolean;
    iconTone: string;
    badgeType?: 'new' | 'new-forms' | 'new-events' | 'new-settings' | 'profile';
  }> = [];
  previousConnectionStatus: any = 'ONLINE';
  firebasePlugin;
  currentAppVerion: any = '';
  userFullName: any = localStorage.getItem('userName');
  personalImage: any = localStorage.getItem('personalImage');
  mercazName: any = localStorage.getItem('mercazName');
  mercazType: any = 0;
  mercazHideNohehut: any = 50;

  constructor(public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen,
    private appVersion: AppVersion,
    private alertCtrl: AlertController,
    private network: Network,
    private toastCtrl: ToastController,
    private iab: InAppBrowser,
    public actionSheetCtrl: ActionSheetController,
    public events: Events,
    private localNotifications: LocalNotifications,
    private webPush: WebPushService,
    private modalCtrl: ModalController,
    private translate: TranslateService,
    private config: Config,
    // private appRate: AppRate,
    // private socialSharing: SocialSharing,
  ) {
    this.initializeApp();
    this.initLanguage();
    this.buildPages();

    events.subscribe('changeLanguage', (language?: string) => {
      const lang = language || localStorage.getItem('language') || 'he';
      this.applyDocumentDirection(lang);
      this.applyIonicLocale(lang);
      this.buildPages();
    });

    events.subscribe('userDataEvent', (data) => {
      this.personalImage = data['workerImage'];
      this.userFullName = data['workerName'];
      this.mercazType = data['mercazType'];
      this.mercazName = localStorage.getItem('mercazName');

      if (this.mercazType == this.mercazHideNohehut) {
        this.pages.forEach(element => {
          switch (element['component']) {
            case 'HugimActivityPage':
            case 'MentortasksPage':
            case 'MentortasksPage':
            case 'MeetingreviewmainPage':
            case 'ChatPage':
              element.hideMenu = true;
              break;
          }

        });

      }
    });

  }

  private initLanguage() {
    const supported = ['he', 'en', 'ar'];
    this.translate.setDefaultLang('he');

    let language = localStorage.getItem('language');
    if (!language || supported.indexOf(language) < 0) {
      language = 'he';
      localStorage.setItem('language', language);
    }

    this.translate.use(language);
    this.applyDocumentDirection(language);
    this.applyIonicLocale(language);
  }

  private applyIonicLocale(language?: string) {
    const lang = language || this.translate.currentLang || localStorage.getItem('language') || 'he';
    this.translate.get([
      'COMMON.back',
      'IONIC.monthNames',
      'IONIC.monthShortNames',
      'IONIC.dayNames',
      'IONIC.dayShortNames',
    ]).subscribe((t: any) => {
      this.config.set('backButtonText', lang === 'he' ? t['COMMON.back'] : '');
      this.config.set('monthNames', t['IONIC.monthNames']);
      this.config.set('monthShortNames', t['IONIC.monthShortNames']);
      this.config.set('dayNames', t['IONIC.dayNames']);
      this.config.set('dayShortNames', t['IONIC.dayShortNames']);
    });
  }

  private applyDocumentDirection(language: string) {
    const dir = language === 'en' ? 'ltr' : 'rtl';
    try {
      document.documentElement.setAttribute('dir', dir);
      document.documentElement.setAttribute('lang', language);
      if (document.body) {
        document.body.setAttribute('dir', dir);
      }
    } catch (e) { /* noop */ }
  }

  private buildPages() {
    this.translate.get('Menu').subscribe((menu: any) => {
      this.pages = [
        { title: menu.HomePage, component: 'HomePage', icon: 'home-outline', hideMenu: false, iconTone: 'home' },
        { title: menu.FormsPage, component: 'FormsPage', icon: 'clipboard-outline', hideMenu: false, iconTone: 'forms', badgeType: 'new-forms' },
        { title: menu.EventsPage, component: 'EventsPage', icon: 'flag-outline', hideMenu: false, iconTone: 'events', badgeType: 'new-events' },
        { title: menu.AbsentViewPage, component: 'AbsentViewPage', icon: 'calendar-outline', hideMenu: false, iconTone: 'schedule', badgeType: 'new' },
        { title: menu.HugimActivityPage, component: 'HugimActivityPage', icon: 'time-outline', hideMenu: false, iconTone: 'activity' },
        { title: menu.MentortasksPage, component: 'MentortasksPage', icon: 'checkmark-circle-outline', hideMenu: false, iconTone: 'tasks' },
        { title: menu.MeetingreviewmainPage, component: 'MeetingreviewmainPage', icon: 'book-outline', hideMenu: false, iconTone: 'lessons' },
        { title: menu.BirthdaysPage, component: 'BirthdaysPage', icon: 'gift-outline', hideMenu: false, iconTone: 'birthdays' },
        { title: menu.EditprofilePage, component: 'EditprofilePage', icon: 'person-outline', hideMenu: false, iconTone: 'profile', badgeType: 'profile' },
        { title: menu.SettingsPage, component: 'SettingsPage', icon: 'settings-outline', hideMenu: false, iconTone: 'settings', badgeType: 'new-settings' },
        { title: menu.ChatPage, component: 'ChatPage', icon: 'chatbubbles-outline', hideMenu: false, iconTone: 'chat' },
        { title: menu.ContactusPage, component: 'ContactusPage', icon: 'mail-open-outline', hideMenu: false, iconTone: 'contact' },
        { title: menu.PhoneSupport, component: 'PhoneSupport', icon: 'call-outline', hideMenu: false, iconTone: 'phone' },
        { title: menu.VideohelpPage, component: 'VideohelpPage', icon: 'videocam-outline', hideMenu: false, iconTone: 'help' },
        { title: menu.SharePage, component: 'SharePage', icon: 'share-outline', hideMenu: false, iconTone: 'share' },
        { title: menu.LogOut, component: 'LogOut', icon: 'log-out-outline', hideMenu: false, iconTone: 'logout' },
      ];

      // Re-apply mercaz menu hides after rebuild
      if (this.mercazType == this.mercazHideNohehut) {
        this.pages.forEach(element => {
          switch (element['component']) {
            case 'HugimActivityPage':
            case 'MentortasksPage':
            case 'MeetingreviewmainPage':
            case 'ChatPage':
              element.hideMenu = true;
              break;
          }
        });
      }
    });
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if (this.platform.is('cordova')) {
        this.statusBar.styleDefault();
        this.splashScreen.hide();
        this.checkVersion();
        this.initializeNetworkEvents();
        this.statusBar.overlaysWebView(false);
      }

      try {
        const raw = localStorage.getItem('rateModalAppLaunches');
        const current = raw ? parseInt(raw, 10) : 0;
        const next = isNaN(current) ? 1 : current + 1;
        localStorage.setItem('rateModalAppLaunches', String(next));
      } catch (e) { /* noop */ }

      if (!this.platform.is('cordova')) {
        this.webPush.initialize();
      }

      let userid: any = Number(localStorage.getItem('user_id'));

      if (userid && userid > 0) {
        this.nav.setRoot(TabsPage);
      } else {
        this.nav.setRoot(LoginPage);
      }

      let beitEmonoalRamatGanServer = localStorage.getItem("beitEmonoalRamatGanServer");

      if (!beitEmonoalRamatGanServer) {
        localStorage.setItem("beitEmonoalRamatGanServer", "0");
      }

      let scannerOptions = localStorage.getItem('scannerOptions');
      if (!scannerOptions) {
        localStorage.setItem('scannerOptions', '0');
      }


      this.firebasePlugin = (<any>window).FirebasePlugin;




      if (this.platform.is('cordova')) {
        if (this.platform.is('android')) {
          this.initializeFireBaseAndroid();

          this.localNotifications.requestPermission().then((pushRequestData) => {
            console.log("requestPermission", pushRequestData)
          }, (pushRequestDataError => {
            console.log("requestPermission", pushRequestDataError)
          }));


          this.localNotifications.on('click').subscribe((notification: any) => {
            if (notification.id === 1) {
              let downloadlink = '';
              if (this.platform.is('android')) {
                downloadlink = 'https://play.google.com/store/apps/details?id=com.atarix.mentor';
              } else {
                downloadlink = 'https://apps.apple.com/us/app/מנטור/id1577401626?mt=8&action=write-review';
              }
              const browser = this.iab.create(downloadlink, '_system');
            }
          });



        }
        if (this.platform.is('ios')) {
          this.initializeFireBaseIos();
        }
      }

      if (this.platform.is('cordova')) {
        this.platform.registerBackButtonAction(() => {
          if (this.nav.length() == 1) {
            let alert = this.alertCtrl.create({
              title: this.translate.instant('APP.exitTitle'),
              //message: 'Do you want to exit?',
              buttons: [
                {
                  text: this.translate.instant('APP.exit'), handler: () => {
                    this.platform.exitApp();
                  }
                },
                { text: this.translate.instant('COMMON.cancel'), role: 'cancel' }
              ]
            });
            alert.present();
          } else {
            this.nav.pop();
          }
        });
      }


      this.userFullName = localStorage.getItem('userName');



    });
  }

  whatsNew(text) {
    if (typeof text == "object" && text.length > 0) {
      let textparse = '';
      text.forEach(element => {
        textparse += '<li>' + element + '</li>';
      });

      let alertBox = this.alertCtrl.create({
        title: this.translate.instant('APP.whatsNew'),
        message: `<ul>` + textparse + ` </ul>`,
        buttons: [this.translate.instant('COMMON.ok')]
      });
      alertBox.present();
    }
    else {
      let alertBox = this.alertCtrl.create({
        title: this.translate.instant('APP.noVersionNotes'),
        buttons: [this.translate.instant('COMMON.ok')]
      });
      alertBox.present();
    }
  }

  async checkVersion() {
    await this.appVersion.getVersionNumber().then((version) => {
      this.currentAppVerion = version;
      let appPlatform = this.platform.is('android') ? 'android' : 'ios';
      fetch(AppSettings.APP_VERSION + '?platform=' + appPlatform)
        .then(response => response.json())
        .then(data => {
          let remote_version = data['app_version'];
          let whatsnew = data['whatsnew'];
          // let version: any = '2.2';
          if (remote_version > version) {
            const modal = this.modalCtrl.create('UpdateappmodalPage', {
              remoteVersion: remote_version,
              currentVersion: version,
              whatsnew: whatsnew,
            }, {
              cssClass: 'update-app-modal',
              enableBackdropDismiss: true,
            });
            modal.present();
          }
        })
        .catch((apiError => {
        }));

    }, (versionError) => {
      console.log(versionError);
    });
  }



  private initializeFireBaseAndroid(): Promise<any> {

    return this.firebasePlugin.getToken(token => {

      this.firebasePlugin.getToken(token => {
        this.sendPushtoserver(token);
        this.firebasePlugin.subscribe("all");
        this.subscribeToPushNotificationEvents();
      });
    });
  }

  private initializeFireBaseIos(): Promise<any> {

    return this.firebasePlugin.grantPermission(data => {
      this.firebasePlugin.getToken(token => {
        this.sendPushtoserver(token);
        this.firebasePlugin.subscribe("all");
        this.subscribeToPushNotificationEvents();
      });
    });
  }



  subscribeToPushNotificationEvents() {
    // Handle token refresh

    this.firebasePlugin.onTokenRefresh((token) => {
      this.sendPushtoserver(token);
    });


    this.firebasePlugin.onMessageReceived((notification) => {
      if (!notification.tap) {
        //alert(JSON.stringify(notification));
      }
      else {

      }
    })
  }


  async sendPushtoserver(token) {
    if (token) {
      // this.config.SetUserPush(token);
      localStorage.setItem("push", token);
    }
  }



  public initializeNetworkEvents(): void {
    this.network.onDisconnect().subscribe(() => {
      if (this.previousConnectionStatus == "ONLINE") {
        this.presentToast(this.translate.instant('APP.offline'));
      }
      this.previousConnectionStatus = "OFFLINE";
      this.events.publish('connectionStatus', 'OFFLINE');
    });
    this.network.onConnect().subscribe(() => {
      if (this.previousConnectionStatus == "OFFLINE") {
        this.presentToast(this.translate.instant('APP.online'));
      }
      this.previousConnectionStatus = "ONLINE";
      this.events.publish('connectionStatus', 'ONLINE');
    });

    this.network.onchange().subscribe(() => {

      setTimeout(() => {
        if (this.network.type === '2g' || this.network.type === '3g' || this.network.type === 'unknown') {
          this.presentToast(this.translate.instant('APP.slowConnection'));
        }
      }, 3000);

    });
  }

  openPage(page) {
    // console.log("page", page);
    if (page.component == "LogOut") {

      let alertBox = this.alertCtrl.create({
        title: '<b>' + this.translate.instant('APP.logoutConfirm') + '</b>',
        subTitle: '',
        buttons: [
          {
            text: this.translate.instant('COMMON.cancel'),
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          },
          {
            text: this.translate.instant('APP.exit'),
            handler: () => {
              this.userFullName = '';
              this.personalImage = '';
              localStorage.removeItem("mercazName");
              localStorage.removeItem("userName");
              localStorage.removeItem("user_id");
              localStorage.removeItem("mercazAllId");
              localStorage.removeItem("mercazImage");
              localStorage.removeItem("server");
              localStorage.removeItem("personalImage");
              localStorage.removeItem("mercazType");
              localStorage.removeItem("csvExportEmail");
              localStorage.setItem("beitEmonoalRamatGanServer", "0");
              if (!this.platform.is('cordova')) {
                this.webPush.resetHomeUserContext();
              }
              this.nav.setRoot(LoginPage);
            }
          }
        ]
      });
      alertBox.present();
    }
    else if (page.component == "HomePage") {
      this.nav.setRoot(TabsPage);
    }
    else if (page.component == "SharePage") {


      if (this.platform.is('cordova')) {
        const shareSubject = this.translate.instant('APP.shareSubject');
        const shareBody = this.translate.instant('APP.shareBody');
        let actionSheet = this.actionSheetCtrl.create({
          title: this.translate.instant('APP.shareApp'),
          buttons: [

            {
              text: this.translate.instant('APP.email'),
              icon: 'mail-outline',
              handler: () => {
                const browser = this.iab.create("mailto:?subject=" + encodeURIComponent(shareSubject) + "&body=" + encodeURIComponent(shareBody + this.translate.instant('APP.shareFooter')), '_system');
              }
            },
            {
              text: this.translate.instant('APP.sms'),
              icon: 'text-outline',
              handler: () => {
                console.log('Archive clicked');
                const browser = this.iab.create("sms:?&body=" + encodeURIComponent(shareBody + this.translate.instant('APP.shareFooter')), '_system');
              }
            },
            {
              text: this.translate.instant('APP.whatsapp'),
              icon: 'logo-whatsapp',
              handler: () => {
                console.log('Archive clicked');
                const browser = this.iab.create("https://api.whatsapp.com/send?text=" + encodeURIComponent(shareBody + this.translate.instant('APP.shareFooter')), '_system');
              }
            },
            // {
            //   text: 'פייסבוק',
            //   icon: 'logo-facebook',
            //   handler: () => {
            //     const browser = this.iab.create("http://www.facebook.com/share.php?u=https://www.atarix.co.il/", '_blank');
            //   }
            // },
            // {
            //   text: 'טוויטר',
            //   icon: 'logo-twitter',
            //   handler: () => {
            //     const browser = this.iab.create("http://twitter.com/share?text=אפלקציית ניהול מדריכים לחוגים ונרשמים\n להורדה אנדרואיד: https://bit.ly/3hTVG4M \n להורדה אייפון: https://apple.co/2UmxcYV&url=https://www.activtec.co.il/page.php?type=parent&id=2640&m=299", '_blank');
            //   }
            // },
            {
              text: this.translate.instant('COMMON.cancel'),
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            }
          ]
        });

        actionSheet.present();
      } else {
        let shareWeb = navigator as any;
        if ('share' in navigator) {
          const url = 'https://bit.ly/3hTVG4M';
          const text = this.translate.instant('APP.shareBody') + this.translate.instant('APP.shareFooter');
          if (shareWeb.share) {
            shareWeb.share({ title: this.translate.instant('APP.shareSubject'), text, url }).catch(() => { });
          }
          else {
            if ('clipboard' in navigator) {
              shareWeb.clipboard.writeText(text);
              this.presentToast(this.translate.instant('APP.copiedClipboard'));
            }
          }
        }
      }



    }


    else if (page.title == this.translate.instant('APP.writeReview')) {
      let downloadlink = '';
      if (this.platform.is('android')) {
        downloadlink = 'https://play.google.com/store/apps/details?id=com.atarix.mentor';
      } else {
        downloadlink = 'https://apps.apple.com/us/app/מנטור/id1577401626?mt=8&action=write-review';
      }
      const browser = this.iab.create(downloadlink, '_system');
    }
    else if (page.component == "PhoneSupport") {
      const browser = this.iab.create("tel:048727969", '_system');
    }
    else {
      this.nav.push(page.component);
    }
  }

  goProfile() {
    this.nav.push('EditprofilePage');
  }

  onMenuOpen() {
    this.syncProfileFromStorage();
  }

  syncProfileFromStorage() {
    this.personalImage = localStorage.getItem('personalImage');
    this.userFullName = localStorage.getItem('userName');
    this.mercazName = localStorage.getItem('mercazName');
  }

  hasProfileImage(): boolean {
    const img = String(this.personalImage || localStorage.getItem('personalImage') || '').trim();
    if (!img || img === 'null' || img === 'undefined') {
      return false;
    }
    const lower = img.toLowerCase();
    if (lower.indexOf('userplaceholder') !== -1) {
      return false;
    }
    if (lower.indexOf('/placeholder') !== -1 || lower.indexOf('placeholder.') !== -1) {
      return false;
    }
    return true;
  }

  showProfileUpdateBadge(): boolean {
    return !this.hasProfileImage();
  }

  getProfileAvatarBadgeText(): string {
    return this.hasProfileImage()
      ? this.translate.instant('Menu.updatePhoto')
      : this.translate.instant('Menu.addPhoto');
  }

  isBirthdaysMenuItem(page: { iconTone?: string; component?: string }): boolean {
    return page.iconTone === 'birthdays' || page.component === 'BirthdaysPage';
  }

  isScheduleMenuItem(page: { iconTone?: string; component?: string }): boolean {
    return page.iconTone === 'schedule' || page.component === 'AbsentViewPage';
  }

  showMenuItemBadge(page: { badgeType?: string }): boolean {
    if (page.badgeType === 'profile') {
      return true;
    }
    return page.badgeType === 'new'
      || page.badgeType === 'new-forms'
      || page.badgeType === 'new-events'
      || page.badgeType === 'new-settings';
  }

  getMenuItemBadgeText(page: { badgeType?: string }): string {
    if (page.badgeType === 'profile') {
      return this.hasProfileImage()
        ? this.translate.instant('Menu.updatePhoto')
        : this.translate.instant('Menu.addPhoto');
    }
    return this.translate.instant('Menu.badgeNew');
  }

  public onImgError(ev: Event, kind: 'profile' | 'matnas' = 'profile'): void {
    const imgEl: any = ev && (ev.target as any);
    if (!imgEl) {
      return;
    }

    // prevent endless error loops
    imgEl.onerror = null;

    if (kind === 'profile') {
      imgEl.src = '../assets/imgs/userplaceholder.png';
      this.personalImage = null;
      try {
        localStorage.removeItem('personalImage');
      } catch (e) { /* noop */ }
      return;
    }

    imgEl.src = 'assets/imgs/logo_no_bg.png';
  }


  presentToast(text) {
    let toast = this.toastCtrl.create({
      message: text,
      duration: 3000,
      position: 'bottom'
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    toast.present();
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts